<template>
  <el-drawer
    :visible.sync="drawer"
    size="46%"
    :modal="false"
    :destroy-on-close="true"
    :with-header="false"
    @close="handleClose"
  >
    <div class="drawer">
      <div class="drawer-left">
        <div class="drawer-close-icon">
          <i class="el-icon-close" @click="handleClose" style="cursor:pointer"></i>
        </div>
      </div>
      <div class="drawer-right">
        <div class="label-text">消息编号</div>
        <div class="content-text">{{ messageModel.subOrder }}</div>
        <div class="label-text">消息标题</div>
        <div class="content-text">{{ messageModel.statusChangeDesc }}</div>
        <div class="label-text">消息内容</div>
        <div class="content-text">{{ messageModel.detailDesc }}</div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
export default {
  props: {
    showDrawer: {
      type: Boolean,
      default: false
    },
    messageModel: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      drawer: false
    }
  },
  watch: {
    showDrawer: {
      handler(val) {
        this.drawer = val
      }
    }
  },
  methods: {
    handleClose() {
      this.drawer = false
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus" scoped>
.drawer
  display flex
  flex-flow row nowrap
  .drawer-left
    flex-shrink 0
    width 50px
    height 100vh
    border-right 1px solid #eee
    .drawer-close-icon
      height 50px
      line-height 50px
      color #fff
      background-color #0a213f
      text-align center
      &:hover
        background-color #48586d
  .drawer-right
    padding 10px 20px
    font-size 14px
    .label-text
      font-weight 600
      margin 20px 0 12px
    .content-text
      line-height 30px
      color #666
</style>
